import createRoute      from '@widesk-ui/tools/createRoute';
import ContactTypeModel from '@models/website/ContactTypeModel';

const route = createRoute.splitView(
	'/configuration/contact_types',
	'website',
	'ContactTypeSplitView',
	ContactTypeModel.localize('plural'),
);
export default route;
